export default __webpack_public_path__ + "static/media/uli.85b4655a.jpg";